import { History } from "history";

import { TFlowItem, TSubMenuItem } from "../interface";

import SysConfig from "@/conf/sys.map.config";
import { getLoginType } from "./env";
import { getDadaCookie, getSsoTicket } from "@/api/menu";

export const routerJump = (history: History, item: any) => {
    if (item.siteOut) {
        window.open(item.url);
    } else {
        const url =
            item.url?.indexOf("http") !== -1
                ? `/iframe-view/${encodeURIComponent(item.url)}`
                : SysConfig.base + SysConfig.hash + item.url;
        history.push(url);
    }
};
export const setCookie = async () => {
    try {
        const res: any = await getSsoTicket();
        if (res.code != "0" || !res.data) return false;
        const dadaCookie: any = await getDadaCookie({ ticket: res.data });
        if (dadaCookie.code != "0" || !dadaCookie.data) return false;
        return true
    } catch (error) {
        console.log("种cookie失败");
        return false
    }

};
// 获取当前路径url；TODO: 目前是 pathName + hash; 看后续有无更好的方式；
// 这种方式，限制了hash的作用；是否可在微引用注册是，标明子应用是 hash 还是 history
export const getPathUrl = () => {
    let pathName = decodeURIComponent(window.location.pathname);
    const hash = decodeURIComponent(window.location.hash);
    const isNestPage = pathName.startsWith("/iframe-view/");
    console.log("pathName", pathName);
    if (isNestPage) {
        pathName = pathName.split("/iframe-view/")[1];
    }

    return pathName + hash;
};

// 获取当前流程节点，当前二级菜单，当前菜单
export const getActiveMenuInfo = (flow: TFlowItem[] = []) => {
    let activeFlow: TFlowItem | undefined; //
    let activeSubMenu: TSubMenuItem[] | undefined;
    let activeChildMenu: TSubMenuItem | undefined;

    const path = getPathUrl()
    let routeUrl = path
    if (path.includes('http')) {
        const parsedUrl = new URL(getPathUrl());
        routeUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.pathname}${parsedUrl.hash}`;
    }

    for (let i = 0; i < flow.length; i++) {
        if (flow[i]?.subMenu) {
            activeChildMenu = flow[i]?.subMenu?.find?.(
                (subMenu) => subMenu?.url.includes(routeUrl)
            );
            if (activeChildMenu) {
                activeSubMenu = flow[i]?.subMenu;
                activeFlow = flow[i];
                break;
            }
        } else {
            let url = flow[i]?.url.startsWith("/iframe-view/")
                ? flow[i]?.url.split("/iframe-view/")[1]
                : flow[i]?.url;
            if (url === routeUrl) {
                activeFlow = flow[i];
                break;
            }
        }
    }

    return {
        activeFlow,
        activeSubMenu,
        activeChildMenu,
    };
};

// 获取当前流程节点，当前二级菜单，当前菜单
export const getSaasActiveMenuInfo = (flow: TFlowItem[] = []) => {
    let activeFlow: TFlowItem | undefined; //
    let activeSubMenu: TSubMenuItem[] | undefined;
    let activeChildMenu: TSubMenuItem | {} = {};

    const path = getPathUrl()
    let routeUrl = path
    if (path.includes('http')) {
        const parsedUrl = new URL(getPathUrl());
        routeUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.pathname}${parsedUrl.hash}`;
    }

    for (let i = 0; i < flow.length; i++) {
        if (flow[i]?.subMenu) {
            activeChildMenu = tree(flow[i].subMenu, routeUrl);

            if (activeChildMenu) {
                activeSubMenu = flow[i]?.subMenu;
                activeFlow = flow[i];
                break;
            }
        } else {
            let url = flow[i]?.url.startsWith("/iframe-view/")
                ? flow[i]?.url.split("/iframe-view/")[1]
                : flow[i]?.url;
            if (url === routeUrl) {
                activeFlow = flow[i];
                break;
            }
        }
    }
    return {
        activeFlow,
        activeSubMenu,
        activeChildMenu,
    };
};
const tree = (menuList: any[] = [], routeUrl: string): any => {
    for (let i = 0; i < menuList.length; i++) {
        const menu = menuList[i];

        if (menu?.url.includes(routeUrl)) {
            return menu;
        } else if (menu.children) {
            const data = tree(menu.children, routeUrl);
            if (data) return data;
        }
    }
    return undefined;
};
export const logout = () => {
    const returnUrl = encodeURIComponent(window.location.href);
    const loginType = getLoginType();
    if (loginType === 3) {
        window.location.href = `//passport.jd.com/uc/login?ltype=logout&ReturnUrl=${returnUrl}`;
    } else {
        const logoutReturnUrl = encodeURIComponent(
            `https://ssa.jd.com/sso/login?ReturnUrl=${returnUrl}`
        );
        window.location.href =
            "//ssa.jd.com/sso/logout?ReturnUrl=" + logoutReturnUrl;
    }
};

/**
 * @description 判断是否被指定系统嵌入
 * @param { string } str 识别字段
 * @returns boolean 返回校验结果
 */
export function checkParentUrl(str = "jxsaasapp") {
    // 判断入参是否为字符串 || 是否被嵌入
    if ((str && typeof str !== "string") || window.top === window.self)
        return false;
    let url = null;

    // 判断是否同域
    if (window.parent !== window) {
        try {
            url = window.parent.location.href;
        } catch (e) {
            url = document.referrer;
        }
    }
    // 次获取方案
    if (!url) {
        try {
            const ancestorUrl = window?.top?.[0].location.ancestorOrigins;
            url = ancestorUrl?.length ? ancestorUrl[0] : null;
        } catch (e) {
            console.log(e);
        }
    }
    return url ? url.includes(str) : false;
}
/**
 * 设定喜牛获取值
 * @param cb 回调成功调用
 */
export function getXnWorkbenchCode(cb?: any) {
    const isXiniu = checkParentUrl();
    const XnWorkbenchCode = JSON.parse(
        localStorage.getItem("CRM_XnWorkbench_Code") || "{}"
    );
    if (XnWorkbenchCode && isXiniu) {
        cb?.();
        return JSON.stringify(XnWorkbenchCode);
    } else {
        return;
    }
}
// 初始化喜牛SDK
export function initXnSdk(cb?: any) {
    (window as any)?.App?.initXnJSBridge?.({
        backFn: () => {
            (window as any)?.App.jsBridge?.getLogininfo?.((res) => {
                if (res?.code == 200) {
                    const { userCode, tenantCode, orgCode } = res?.data || {};
                    const xnParams = JSON.stringify({
                        userCode,
                        tenantCode,
                        orgCode,
                    });
                    // localStorage.setItem("userCode", userCode);
                    localStorage.setItem("CRM_XnWorkbench_Code", xnParams);
                    console.info("initXnJSBridge", res.data);
                    cb?.(xnParams);
                }
            });
        },
        tracking: false,
    });
}

export const appendUrlParams = (
    url: string,
    params: Record<string, string>
) => {
    try {
        const urlObj = new URL(url);
        Object.keys(params).forEach((key) => {
            urlObj.searchParams.set(key, params[key]);
        });
        return urlObj.toString();
    } catch (e) {
        return url;
    }
};

export const getUrlParams = (url: string): any => {
    const str = url.slice(url?.indexOf("?") + 1);
    const arr = str.split("&");
    const result: any = {};
    for (let i = 0; i < arr.length; i++) {
        const item = arr[i].split("=");
        result[item[0]] = item[1];
    }
    return result;
};
